var ESubscriptionStatus;
(function(ESubscriptionStatus) {
    ESubscriptionStatus["Active"] = "active";
    ESubscriptionStatus["CancellationPending"] = "cancellationPending";
    ESubscriptionStatus["Canceled"] = "canceled";
    ESubscriptionStatus["Revoked"] = "revoked";
})(ESubscriptionStatus || (ESubscriptionStatus = {}));
var ESubscriptionCancellationReason;
(function(ESubscriptionCancellationReason) {
    ESubscriptionCancellationReason["ProductIssue"] = "productIssue";
    ESubscriptionCancellationReason["BetterAlternativeFound"] = "betterAlternativeFound";
    ESubscriptionCancellationReason["TooExpensive"] = "tooExpensive";
    ESubscriptionCancellationReason["NoNeedAnymore"] = "noNeedAnymore";
    ESubscriptionCancellationReason["PaymentFailed"] = "paymentFailed";
    ESubscriptionCancellationReason["Unknown"] = "unknown";
})(ESubscriptionCancellationReason || (ESubscriptionCancellationReason = {}));
export { ESubscriptionStatus, ESubscriptionCancellationReason };
